import { useRouter } from 'next/router';

import { MetaHead } from 'common/metaHead';
import { InfoParamsContextProvider } from 'contexts/infoParams';
import { RecommendParamsContextProvider } from 'contexts/recommendParams';
import { SearchParamsContextProvider } from 'contexts/searchParams';
import EverywhereFlights from 'everywhere/monthly';

const EverywherePage = () => {
  const router = useRouter();
  const { continents, country, months, theme } = router.query;
  return (
    <>
      <MetaHead />
      <SearchParamsContextProvider>
        <RecommendParamsContextProvider
          continents={continents as string}
          country={country as string}
          months={months as string}
          theme={theme as string}
        >
          <InfoParamsContextProvider>
            <EverywhereFlights />
          </InfoParamsContextProvider>
        </RecommendParamsContextProvider>
      </SearchParamsContextProvider>
    </>
  );
};

export default EverywherePage;
